export var initialSelection = {
  start: 0,
  end: 0,
  text: ''
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown-editor-lite/esm/share/var.js
// module id = 1471
// module chunks = 0